import { PartnerLocation } from "../data/location";
import { fillTokens } from "../fm/lib/email_preview";

type LabelledLocation = Pick<
  PartnerLocation,
  "name" | "streetAddress" | "city" | "neighborhood"
>;

const DEFAULT_LOCATION_LABEL = "${location_name} - ${location_street_address}";

// A partner sets its own template when name + street address reads badly
// (e.g. names that already are the street); unknown placeholders stay as typed
// so a typo is visible on the page rather than silently blank. Every value is
// coalesced to "" because fillTokens prints a null value's token as typed.
export function contactFormLocationLabel(
  location: LabelledLocation,
  template?: string
): string {
  return fillTokens(template?.trim() || DEFAULT_LOCATION_LABEL, {
    "${location_name}": location.name ?? "",
    "${location_street_address}": location.streetAddress ?? "",
    "${location_city}": location.city ?? "",
    "${location_neighborhood}": location.neighborhood ?? "",
  });
}
